import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsModalOpen,
  setRowStatus,
} from "../../state-management/actions/global-state-actions";
import Button from "../basicComponents/button";
import theme from "../../config/theme";
import "../../styles/modal.css";

const Modal: React.FC = () => {
  const dispatch = useDispatch();
  const { isModalOpen } = useSelector((state: any) => state.globalState);
  const { modalData } = useSelector((state: any) => state.globalState);
  const { rowStatus } = useSelector((state: any) => state.globalState);
  const { theme: themeMode } = useSelector((state: any) => state.globalState);
  const mode = themeMode === "light" ? theme.light : theme.dark;
  const [isClosing, setIsClosing] = useState(false);

  const closeModal = () => {
    setIsClosing(true);
    setTimeout(() => {
      dispatch(setIsModalOpen(false));
      setIsClosing(false);
    }, 300);
  };

  const handleConfirm = () => {
    if (modalData.confirmAction) {
      modalData.confirmAction();
      if (rowStatus.id === modalData.id) {
        dispatch(setRowStatus("", false));
      }
    }
    closeModal();
  };

  return (
    <>
      {isModalOpen && (
        <div className="modal" style={{ fontFamily: mode.fontFamily.normal }}>
          <div
            className="overlay"
            style={{
              backgroundColor: mode.backgroundColor.bgSecondary,
              opacity: 0.3,
            }}
          ></div>
          <div
            className={`modal-content ${
              isClosing ? "modal-close" : ""
            } flex flex-col gap-y-11 justify-start md:w-[450px] w-[300px] border border-[#6bd5ca]`}
            style={{
              backgroundColor: mode.backgroundColor.bgPrimary,
            }}
          >
            <h2
              className="font-semibold"
              style={{ color: mode.color.textPrimary, fontSize: "16px" }}
            >
              {modalData.title}{" "}
            </h2>
            <p style={{ color: mode.color.textPrimary, fontSize: "14px" }}>
              {modalData.message}
            </p>
            <div className="flex justify-end" style={{gap:"10px"}}>
              <Button title="بستن" onClick={closeModal} />
              {modalData.buttonText ? (
                <Button title={modalData.buttonText} onClick={handleConfirm} />
              ) : null}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
